/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVIcon24Regular = forwardRef('DataChartBarsXyVIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3 3a.75.75 0 0 1 .75.75V18A2.25 2.25 0 0 0 6 20.25h15.25a.75.75 0 0 1 0 1.5H6A3.75 3.75 0 0 1 2.25 18V3.75A.75.75 0 0 1 3 3Z" }),
        React.createElement("path", { d: "M7 12.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M11.75 7a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0V7Z" }),
        React.createElement("path", { d: "M19 3.25a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M15.75 10a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0v-7Z" })));
});
